var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4574 4.1814H6.6858V5.2914C7.0068 4.653 7.83 4.0794 9.0666 4.0794C11.4372 4.0794 12 5.3502 12 7.6818V12H9.6V8.2128C9.6 6.885 9.279 6.1362 8.4618 6.1362C7.3284 6.1362 6.8574 6.9432 6.8574 8.2122V12H4.4574V4.1814V4.1814ZM0.342 11.898H2.742V4.0794H0.342V11.898V11.898ZM3.0858 1.53C3.08589 1.73117 3.04599 1.93034 2.96843 2.11595C2.89087 2.30156 2.77719 2.46991 2.634 2.6112C2.34384 2.89957 1.95109 3.06099 1.542 3.06C1.13363 3.05973 0.741787 2.89872 0.4512 2.6118C0.308527 2.47003 0.195232 2.30149 0.117806 2.11586C0.0403809 1.93022 0.000347479 1.73113 0 1.53C0 1.1238 0.162 0.735 0.4518 0.4482C0.742131 0.160895 1.13414 -0.000179526 1.5426 1.50159e-07C1.9518 1.50159e-07 2.3442 0.1614 2.634 0.4482C2.9232 0.735 3.0858 1.1238 3.0858 1.53Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.b562182c9807a52536647b61d07f0608.svg";
export { ForwardRef as ReactComponent };